import { useEffect, useState, type ReactNode } from "react";
import { GfButton, GfField, GfModal } from "../ui/GfUi";

/** 確認ダイアログ（任意でメモ入力を必須にできる）。再発行・無効化・削除・中止・段階修正で共用 */
export function ConfirmModal({
  open,
  title,
  message,
  confirmLabel,
  danger,
  requireNote,
  noteLabel = "理由（メモ）",
  busy,
  onConfirm,
  onClose,
  children,
}: {
  open: boolean;
  title: ReactNode;
  message?: ReactNode;
  confirmLabel: string;
  danger?: boolean;
  requireNote?: boolean;
  noteLabel?: string;
  busy?: boolean;
  onConfirm: (note: string) => void;
  onClose: () => void;
  children?: ReactNode;
}) {
  const [note, setNote] = useState("");
  useEffect(() => {
    if (open) setNote("");
  }, [open]);
  const blocked = busy || (requireNote && !note.trim());
  return (
    <GfModal
      open={open}
      title={title}
      onClose={onClose}
      width={440}
      footer={
        <>
          <GfButton onClick={onClose} disabled={busy}>
            やめる
          </GfButton>
          <GfButton variant={danger ? "danger" : "primary"} disabled={blocked} onClick={() => onConfirm(note.trim())}>
            {busy ? "処理中…" : confirmLabel}
          </GfButton>
        </>
      }
    >
      {message && <div className="gf-confirm-msg">{message}</div>}
      {children}
      {requireNote && (
        <GfField label={`${noteLabel}（必須）`}>
          <textarea className="gf-textarea" value={note} onChange={(e) => setNote(e.target.value)} rows={3} />
        </GfField>
      )}
    </GfModal>
  );
}
